import template from './leave_auto_link_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveAutoLinkHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveAutoLinkHelpPage
{
	constructor (bindings) {
		this.viewModel = new LeaveAutoLinkHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveAutoLinkHelp',
	dialog_class: LeaveAutoLinkHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_auto_link_help',
	provider: 'ps'
};
